import React, { useCallback } from 'react';
import { set } from 'dot-prop-immutable';
import { toolFormAttr, toolCollapseAttr } from '@utils/util';
import HeightSetting from '@whalecloud/page-builder-base-components/components/ElementSettings/HeightSetting';
import WidthSetting from '@whalecloud/page-builder-base-components/components/ElementSettings/WidthSetting';
import GridSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonGridSettings';
import { SimpleForm as Form, Collapse, Input, Select, Switch, Radio } from '@whalecloud/fdx';
import { getLocale } from '@utils/util';
import TabsSettingsTable from './TabsSettingsTable';

const { Panel } = Collapse;
const { Option } = Select;

const valueKey = "data.formItemSettings";
const formKey = "data.formSettings";

const TabsSetting = (props) => {
  const messages = getLocale();
  
  const { updateElement, element } = props;
  const { formItemSettings = {}, formSettings = {}, settings = {} } = element.data;
  const { tabs, ...resetProps } = formItemSettings;
  const { visible = true } = settings;
  const { elements = [] } = element;

  const initialValues = {
    size: 'default',
    tabPosition: 'top',
    type: 'line',
    defaultActiveKey: elements[0].id,
    visible,
    ...formSettings,
    ...resetProps
  }

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      let propName = `${valueKey}.${key}`;
      let value = obj[key];
      if (['name', 'label'].includes(key)) {
        propName = `${formKey}.${key}`;
      }
      if (key === 'visible') {
        propName = `data.settings.${key}`
        value = obj[key] ? 'visible' : 'hidden';
      }
      const newElement = set(element, propName, value);
      updateElement({
        element: newElement
      });
    })
  }

  const renderOption = useCallback(
    () => tabs.map((item, index) => (<Option key={`tab_key_${elements[index].id}`} value={elements[index].id}>{item.text}</Option>)),
    [tabs, elements]
  )

  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_NAME']} name="name">
            <Input placeholder="Input the form field name" />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_LABEL_TEXT']} name="label">
            <Input placeholder="Input the form field label" />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_VISIBLE']} name="visible" valuePropName="checked">
            <Switch />
          </Form.Item>
          <GridSettings />
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_SIZE']} name="size">
            <Radio.Group size="small">
              <Radio.Button value="small">{messages['PAGEBUIDER_SETTINGS_SMALL']}</Radio.Button>
              <Radio.Button value="default">{messages['PAGEBUIDER_SETTINGS_DEFAULT']}</Radio.Button>
              <Radio.Button value="large">{messages['PAGEBUIDER_SETTINGS_LARGE']}</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_TAB_POSITION']} name="tabPosition">
            <Radio.Group size="small">
              <Radio.Button value="top">{messages['PAGEBUIDER_SETTINGS_PLACEMENT_TOP']}</Radio.Button>
              <Radio.Button value="right">{messages['PAGEBUIDER_SETTINGS_PLACEMENT_RIGHT']}</Radio.Button>
              <Radio.Button value="bottom">{messages['PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOM']}</Radio.Button>
              <Radio.Button value="left">{messages['PAGEBUIDER_SETTINGS_PLACEMENT_LEFT']}</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_TAB_TYPE']} name="type">
            <Radio.Group size="small">
              <Radio.Button value="line">line</Radio.Button>
              <Radio.Button value="card">card</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_TAB_DEFAULT_KEY']} name="defaultActiveKey">
            <Select>
              {renderOption()}
            </Select>
          </Form.Item>
        </Form>
        <HeightSetting />
        <WidthSetting />
      </Panel>
      <Panel header={messages['PAGEBUIDER_SETTINGS_TAB_POSITION']} key="2">
        <TabsSettingsTable element={element} updateElement={updateElement} />
      </Panel>
    </Collapse>
  );
};

export default TabsSetting;

